'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var React = require('react');
var React__default = _interopDefault(React);
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
var pagination = require('./pagination-665adfae.js');
var enums$1 = require('./enums-097a7f7b.js');
var useTableContext_hook = require('./useTableContext.hook-ec1eae40.js');

var StyledPagination = styled__default.div(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n  padding: 14px 16px;\n"], ["\n  padding: 14px 16px;\n"])));
var HqOTableFooter = function (_a) {
    var _b = _a.footerType, footerType = _b === void 0 ? enums$1.FooterStyle.footerWithPagination : _b, footerComponent = _a.footerComponent, className = _a.className;
    var _c = useTableContext_hook.useTableContext(), version = _c.version, paginationProps = _c.paginationProps;
    var _d = paginationProps, page = _d.page, setPage = _d.setPage, limit = _d.limit, setLimit = _d.setLimit, offset = _d.offset, total = _d.total, labels = _d.labels;
    if (version === 2 || footerType === enums$1.FooterStyle.noFooter) {
        return null;
    }
    return (React__default.createElement(StyledPagination, { "data-testid": "hqo-table-footer", className: className + "-footer" },
        footerType === enums$1.FooterStyle.footerWithPagination && (React__default.createElement(pagination.Pagination, { page: page, setPage: setPage, limit: limit, setLimit: setLimit, offset: offset, total: total, labels: labels })),
        footerType === enums$1.FooterStyle.customFooter && footerComponent));
};
var templateObject_1;

exports.HqOTableFooter = HqOTableFooter;
